// @flow

import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import { AuthConsumer } from '../../contexts/Auth';

type Props = {
  children?: any,
};

type Auth = {
  isAuthenticated: boolean,
  authCookie: string,
};

const Apollo = ({ children }: Props) => (
  <AuthConsumer>
    {({ authCookie }: Auth) => {
      const auth = authCookie;
      const client = new ApolloClient({
        uri:
          process.env.REACT_APP_ENV === 'staging'
            ? process.env.REACT_APP_GRAPHQL_ENDPOINT_STAGING
            : process.env.REACT_APP_GRAPHQL_ENDPOINT,
        request: async operation => {
          operation.setContext({
            headers: { auth },
          });
        },
      });

      return <ApolloProvider client={client}>{children}</ApolloProvider>;
    }}
  </AuthConsumer>
);

export default Apollo;
